import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Chip, FormControl } from "@mui/material";

const versions: number[] = [0.0, 1.0, 1.1, 2.0, 3.0, 4.0, 5.0, 15.0, 34.0];

const VersionSelector: React.FC = ({ handleChange, selection }: any) => {
  const [selectedVersions, setSelectedVersions] = useState<(string | number)[]>(
    selection || []
  );

  // Sync state when filters reset
  useEffect(() => {
    setSelectedVersions(selection || []);
  }, [selection]);

  const handleVersionChange = (event: any, newValue: (string | number)[]) => {
    setSelectedVersions(newValue);
    handleChange("documentVersion")(newValue);
  };

  return (
    <FormControl fullWidth>
      <Autocomplete
        multiple
        freeSolo
        options={versions}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.toString()
        }
        value={selectedVersions}
        onChange={handleVersionChange}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              label={typeof option === "string" ? option : option.toString()}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select or Add Versions"
            placeholder="Type or select versions"
          />
        )}
      />
    </FormControl>
  );
};

export default VersionSelector;
